import mapErrors from '@/utils/mapErrors.utils';
import { hasProp } from '@/utils/validate.utils';
import { consoleError } from '@/utils/console.utils';

/**
 * Errores personalizados dentro de la aplicación
 */
class AppError extends Error {
  /**
   * Crea un error personalizado
   *
   * @param {String} errorId - Código del error
   * @param {String} errorDescription - Descripción del error
   */
  constructor(errorId, errorDescription) {
    let description = '';

    /**
     * Obtiene la descripción del error
     * 1- Descripción enviada por el usuario
     * 2- Error en nuestro map de errores
     */
    if (errorDescription) {
      description = errorDescription; // [1]
    } else if (hasProp(mapErrors, errorId)) {
      description = mapErrors[errorId][1]; // [2]
    }

    super(description);

    this.name = this.constructor.name;
    this.errorId = errorId;
    this.description = description;
  }
}

/**
 * Obtiene el id del error
 *
 * @param {Error, AppError} error - Objeto Error
 * @return {String, Null} Código del error
 */
/* prettier-ignore */
const getErrorId = (error, showLog = true) => {
  let errorId = null;
  let description = null;

  /**
   * Obtengo el errorID según el tipo de console.error();
   *
   * 1- Error personalizado "AppError"
   * 2- Errores devueltos por el API
   * 3- Errores devueltos por el Backend
   * 4- Errores dentro de la aplicación
   * 5- Cualquier otro error
   */
  if (error.errorId) {
    errorId = error.errorId; // [1]
  } else if (error.response && error.response.data && error.response.data._id) {
    errorId = error.response.data._id; // [2]
  } else if (error.response && error.response.status) {
    errorId = error.response.status; // [3]
  } else if (error.name) {
    errorId = error.name; // [4]
  } else {
    errorId = 'default'; // [5]
  }

  /**
   * Obtiene la descripción del error
   * 1- Error personalizado "AppError"
   * 2- Error en nuestro map de errores
   * 3- Cualquier otro error
   */
  if (error.description) {
    description = error.description; // [1]
  } else if (hasProp(mapErrors, errorId)) {
    description = mapErrors[errorId][1]; // [2]
  } else {
    description = error.message; // [3]
  }

  /**
   * Imprime por consola los datos del error
   */
  if (showLog) {
    consoleError(`${errorId} - ${description}`);
    // console.error(error);
  }

  return errorId;
};

export default AppError;

export { getErrorId };
